import React from 'react';

import { flagStyles } from '../settings';

const SvgFM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1704px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgFM;
